declare const THREE: any;

export class SceneImage {

  private static getPixels(renderer): ImageData {
    const sceneCanvas = renderer.domElement;
    const sceneCanvasWidth = sceneCanvas.width;
    const sceneCanvasHeight = sceneCanvas.height;
    const sceneCanvasCnx = renderer.getContext();
    const pixelData = new Uint8Array(sceneCanvasWidth * sceneCanvasHeight * 4);
    sceneCanvasCnx.readPixels(0, 0, sceneCanvasWidth, sceneCanvasHeight, sceneCanvasCnx.RGBA, sceneCanvasCnx.UNSIGNED_BYTE, pixelData);
    return new ImageData(new Uint8ClampedArray(pixelData), sceneCanvasWidth, sceneCanvasHeight);
  }

  private static sceneImage(imageData: ImageData): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const cnx = canvas.getContext('2d');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    cnx.putImageData(imageData, 0, 0);
    return canvas;
  }

  private static resizeToPowerOf2(originalCanvas: HTMLCanvasElement): HTMLCanvasElement {
    const {width, height} = originalCanvas;
    const newWidth = THREE.Math.ceilPowerOfTwo(width);
    const newHeight = THREE.Math.ceilPowerOfTwo(height);
    const scaleW = newWidth / width;
    const scaleH = newHeight / height;
    const canvas = document.createElement('canvas');
    canvas.width = newWidth;
    canvas.height = newHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(originalCanvas, 0, 0, width * scaleW, height * scaleH);
    return canvas;
  }

  static getScreenshot(renderer): HTMLCanvasElement {
    const imageData = SceneImage.getPixels(renderer);
    const canvas = SceneImage.sceneImage(imageData);
    return SceneImage.resizeToPowerOf2(canvas);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/lightMap/SceneImage.ts